var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCricket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EAEAE4"
    },
    points: "492.451,51.353 449.058,94.747 435.673,108.132 413.26,130.545 399.875,143.93  367.303,176.502 334.966,144.154 387.899,91.232 460.115,19.016 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.179,
    y: 1.174,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 629.0219 439.8779)",
    style: {
      fill: "#D1D1CB"
    },
    width: 22.867,
    height: 176.98
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFBC4B"
    },
    d: "M388.754,223.329l-181.97,181.97l-85.43,85.43l-12.627,12.627c-10.095,10.095-26.451,10.085-36.546,0 L8.105,439.281c-10.085-10.085-10.095-26.451,0-36.546l280.038-280.028c10.085-10.095,26.451-10.085,36.535,0l64.075,64.075 C398.838,196.868,398.849,213.234,388.754,223.329z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3A13D"
    },
    d: "M206.783,405.299l-85.43,85.43c-9.059-10.587-14.518-24.325-14.518-39.334 c0-33.48,27.134-60.614,60.614-60.614C182.469,390.781,196.207,396.24,206.783,405.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D3A13D"
    },
    d: "M22.481,417.11l280.031-280.031c10.094-10.094,26.456-10.086,36.543,0l-14.374-14.374 c-10.086-10.086-26.448-10.094-36.543,0L8.108,402.737c-10.094,10.094-10.086,26.456,0,36.543l14.374,14.374 C12.395,443.566,12.388,427.203,22.481,417.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455256"
    },
    d: "M388.757,223.325l-7.985,7.985L280.153,130.691l7.985-7.985c10.094-10.094,26.456-10.086,36.543,0 l64.076,64.076C398.844,196.868,398.851,213.23,388.757,223.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#455256"
    },
    d: "M507.283,37.001L474.461,4.179c-5.572-5.572-14.608-5.572-20.18,0l0,0 c-5.572,5.572-5.572,14.608,0,20.18l32.822,32.822c5.572,5.572,14.608,5.572,20.18,0l0,0 C512.856,51.609,512.856,42.574,507.283,37.001z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#374447"
    },
    d: "M469.319,19.216c5.572-5.572,14.607-5.572,20.18,0L474.462,4.179c-5.572-5.572-14.608-5.572-20.18,0 l0,0c-5.572,5.572-5.572,14.608,0,20.18l15.037,15.037C463.746,33.824,463.746,24.789,469.319,19.216z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E22342"
    },
    points: "449.058,94.747 435.673,108.132 429.68,81.778 423.686,55.445 437.083,42.048  443.065,68.392  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E22342"
    },
    points: "413.26,130.545 399.875,143.93 393.882,117.576 387.899,91.232 401.285,77.846  407.267,104.19  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E22342"
    },
    cx: 207.588,
    cy: 451.39,
    r: 60.609
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9183A"
    },
    d: "M185.349,451.391c0-26.766,17.357-49.463,41.425-57.491c-6.031-2.012-12.477-3.117-19.184-3.117 c-33.473,0-60.61,27.135-60.61,60.609S174.115,512,207.59,512c6.708,0,13.154-1.106,19.184-3.117 C202.707,500.854,185.349,478.157,185.349,451.391z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C9183A"
    },
    points: "401.285,77.846 407.267,104.19 393.882,117.576 387.899,91.232  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C9183A"
    },
    points: "443.065,68.392 429.68,81.778 423.686,55.445 437.083,42.048  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricket);
export default __webpack_public_path__ + "static/media/cricket.7fb86abebf6c6014950236dc10e8b787.svg";
export { ForwardRef as ReactComponent };